import React, { useEffect, useState } from "react";
import logo from '../img/logo.png';
import bg from "../img/bglogin.jpg";
import adi from "../img/adi.png";
import ct from "../img/logo_CircularTool.png";
import bv from "../img/Bureau_Veritas_1828_logo.png";
import LoginForm from "./LoginForm";
import ResetForm from "./ResetForm";
import RecuperaForm from './RecuperaForm';
import Genimposervice from "../services/setup/Genimposervice";
import Translate from "./Translate";

function Login() {

    const modes = {
        recuperapsw: 1,
        reset: 2,
    }
    const [versione, setVersione] = useState(null);
    const [mode, setMode] = useState(null);
    const [resetToken, setResetToken] = useState(null);

    useEffect(() => {
        Genimposervice.versione().then(response => setVersione(response?.data?.versione || ''));
    }, []);

    useEffect(() => {
        const t = window.location.pathname.split('/');
        if (t[1] === 'resetpassword') {
            setMode(modes.reset);
            setResetToken(t[2])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <div
                className="bgLogin"
                style={{
                    backgroundImage: `url(${bg})`,
                    display: 'flex',
                    justifyContent: 'center',
                    height: '100%',
                }}
            >
                <div className="overflow-hidden position-absolute d-flex rotondo" style={{
                    top: '25%',
                    width: '76rem',
                    minHeight: '30rem',
                    zIndex: 2,
                }}>
                    <div style={{
                        padding: '1.5rem 4rem',
                        backgroundColor: 'rgba(255,255,255,.8)',
                        color: 'rgb(83,91,95)',
                        flexBasis: '50%',
                    }}>
                        <div className="d-flex justify-content-between text-center" style={{
                            flexDirection: 'column',
                            height: '100%',
                        }}>
                            <div className="text-center">
                                <img src={logo} alt="Matrec" className="mt-5" style={{
                                    width: '50%',
                                }} />
                                <br />
                                <br />
                                <br />
                                <br />
                            </div>
                            <div>
                                <img src={ct} alt="Circular Tool" style={{
                                    width: '70%',
                                }} />
                            </div>
                            <div>
                                <br />
                                <div className="loginInfoText">
                                    <Translate chiave="INTROTEXT" pacchetto="Login" />
                                    <br />
                                    <br />
                                    <br />
                                    <a href="https://www.matrec.com/circular-tool"
                                        target="_blank"
                                        rel='noopener noreferrer'
                                        style={{ color: 'rgb(83,91,95)' }}
                                        className="font-weight-bold"
                                    >
                                        <Translate chiave="MOREINFO" pacchetto="Login" />
                                    </a>

                                </div>
                                <div style={{ paddingBottom: '1rem' }}>
                                    <div className="d-flex align-items-end">
                                        <div>
                                            <img src={bv} alt="Bureau Veritas" style={{
                                                width: '3.75rem',
                                            }} />
                                        </div>
                                        <div className="text-left pl-5" style={{ fontSize: '12px' }}>
                                            <Translate chiave="VALIDAZIONE" pacchetto="Login" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-primary" style={{
                        flexBasis: '50%',
                        color: '#fff',
                    }}>
                        {mode === null && (
                            <LoginForm onChangeToRecupera={() => setMode(modes.recuperapsw)} />
                        )}
                        {mode === modes.recuperapsw && (
                            <RecuperaForm onChangeToLogin={() => setMode(null)} />
                        )}
                        {mode === modes.reset && (
                            <ResetForm token={resetToken} onChangeToLogin={() => setMode(null)} />
                        )}
                    </div>
                </div>
            </div >
            <div
                style={{
                    bottom: 0,
                    width: '100%',
                    textAlign: 'center',
                    fontSize: '80%',
                }}
                className="position-absolute"
            >
                <div>
                    <div className="d-flex align-items-center justify-content-center">
                        <div>
                            <img src={adi} alt="ADI" style={{
                                width: '2rem',
                            }} />
                        </div>
                        <div className="text-left pl-3 text-grigiosc" style={{ fontSize: '12px' }}>
                            <Translate chiave="ADI" pacchetto="Login" />
                        </div>
                    </div>
                </div>
                <div className="text-grigiosc pb-3" style={{ fontSize: '12px' }}>
                    <Translate chiave="VER" pacchetto="Login" />
                    {' '}
                    {versione}
                </div>

            </div>
        </>
    );
}

export default Login;